import React from 'react';
import PropTypes from 'prop-types';
import { getInteropCodesFromState } from 'dmpconnectjsapp-base/helpers/accessors';
import { connect } from 'react-redux';
import { professionOidToCardType } from '../../../dmpconnect/helpers/user';
import PsNameWithOverlay from '../../PS/PsNameWithOverlay';
import TitleTooltip from '../../Common/TitleTooltip';

const AuthorsCell = ({ authors, isPatient, professions }) => {
  if (!authors || (!!authors && authors.length === 0)) return null;

  const [author] = authors;
  if (!author) return null;
  
  const profession = professions.find(p => p.code === author.s_hpProfession);
  return (
    <div className="d-flex align-items-center justify-content-start">
      {isPatient ? (
        <TitleTooltip id={`ps-doc-author${author.s_hpInternalId}`} text="Patient">
          <span className="mr-1 badge-profession badge-profession-pat-1" />
        </TitleTooltip>
      ) : (
        <TitleTooltip id={`ps-doc-author${author.s_hpInternalId}`} text={profession ? profession.label : ''} showTooltip={!!profession}>
          <span className={`mr-1 badge-profession badge-profession-${author.s_hpProfession}-${professionOidToCardType(author.s_hpProfessionOid)}`} />
        </TitleTooltip>
      )}
      <PsNameWithOverlay
        name={author.s_hpName}
        given={author.s_hpGiven}
        profession={author.s_hpProfession}
        professionOid={author.s_hpProfessionOid}
        professionDesc={author.s_hpProfessionDescription}
        specialty={author.s_hpSpecialityDescription}
        rpps={author.s_hpInternalId}
        institution={author.Institution ? author.Institution.s_name : author.s_hpInstitution}
        id={author.s_hpInternalId}
        popoverPlacement="bottom-start"
      />
    </div>
  );
};

AuthorsCell.propTypes = {
  authors: PropTypes.array.isRequired,
  isPatient: PropTypes.bool,
  professions: PropTypes.array.isRequired,
};

AuthorsCell.defaultProps = {
  isPatient: false,
};

function mapStateToProps(state) {
  return {
    professions: getInteropCodesFromState(state, 'professions'),
  };
}

export default connect(mapStateToProps)(AuthorsCell);
